// @format
import React from 'react';
import styled from 'styled-components';
import imgLogo from '../assets/img/reta-logo.svg';

const Wrapper = styled.div`
  padding-left: 56px;
  padding-top: 56px;
  box-sizing: border-box;
`;

export default () => (
  <Wrapper>
    <img alt="Reta Logo" src={imgLogo} />
  </Wrapper>
);
